// extracted by mini-css-extract-plugin
export default {"media":"uxiutQ","mediaVideo":"kGIE0d"};